import { __ } from "@wordpress/i18n";
import WelcomeHeader from "./components/WelcomeHeader";
import InfoCards from "./components/InfoCards";
import FeatureSection from "./components/FeatureSection";

// Get plugin URL from global variable with fallback
const pluginUrl = window.cocaBaisDashboard?.pluginUrl || "";

// Define image paths with fallbacks - avoiding any undefined property access
const getImagePath = (imageName) => {
    // Try multiple paths to find the working one
    const paths = [
        // Path 1: Direct from plugin URL to assets/lib/images
        pluginUrl + "assets/lib/images/" + imageName + ".png",
        // Path 2: src/lib/images path
        pluginUrl + "src/lib/images/" + imageName + ".png",
    ];
    // Return the first non-empty path
    return paths.find((path) => path && path.length > 0) || "";
};

const Dashboard = () => {
    const bgImage = getImagePath("dashboard-banner");

    const bgStyle = {
        background: `url(${bgImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
    };
    return (
        <>
            <div style={bgStyle}>
                <WelcomeHeader />
                <FeatureSection />
            </div>
            <InfoCards />
        </>
    );
};

export default Dashboard;
